import 'core-js'

// Modules
import Navigation from 'modules/_navigation'
import ObjectFit from 'modules/_object-fit'
import Print from 'modules/_print'
import EmployeesFilter from './modules/_employees-filter'
import ImageGallery from './modules/_image-gallery'
import GoogleMaps from './modules/_google-maps'
import Modal from './modules/_modal'
import NavigationSearch from './modules/_navigation-search'
import subNavigation from './modules/_subnavigation'
import TestimonialsSlider from './modules/_testimonials-slider'
import TextImageVideo from './modules/_text-image-video'
import VideoModal from './modules/_video-modal'
import SocialShare from './modules/_social-share'

// Register modules
Navigation()
ObjectFit()
Print()
EmployeesFilter()
TestimonialsSlider()
TextImageVideo()
ImageGallery()
Modal()
GoogleMaps()
NavigationSearch()
subNavigation()
VideoModal()
SocialShare()